import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {OrdersApiService} from '../../../../../Services/Api/Purchases/Orders/orders-api.service';
import {OrderWidgetDto} from '../../../../../Models/Purchases/Orders/order-widget.interface';
import {OrderStatusEnum} from '../../../../../Shared/Enum/order-status.enum';

@Component({
  selector: 'app-last-orders-widget',
  templateUrl: './last-orders-widget.component.html',
  styleUrls: ['./last-orders-widget.component.scss'],
  standalone: false,
})
export class LastOrdersWidgetComponent extends WidgetDataControllerComponent<OrderWidgetDto[]> {

  orderStatus = OrderStatusEnum;

  get widgetData(): OrderWidgetDto[] {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ordersService: OrdersApiService,
  ) {
    super(injector, ordersService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = [
      {
        id: 858731,
        ref: "0858731",
        fecha: "1741361252000",
        fecha_recepcion: "1741361252000",
        importe_iva: 3.74,
        enviado: true,
        id_local: 22,
        local: "Yurest",
        proveedor: "Cocina Central",
        proveedor_logo: "",
        id_estado: 2,
        estado: "Enviado",
        should_see_price_by_provider_context: 1,
      },
      {
        id: 858699,
        ref: "0858699",
        fecha: "1741303880000",
        fecha_recepcion: "1741303880000",
        importe_iva: 631.21,
        enviado: false,
        id_local: 469,
        local: "Patties Burger",
        proveedor: "Cocina Central",
        proveedor_logo: "",
        id_estado: 1,
        estado: "Pendiente",
        should_see_price_by_provider_context: 1,
      },
    ];
  }


  /**
   * Obtener los últimos pedidos
   *
   */
  override setData(data: OrderWidgetDto[]) {
    const localFilter: number = this.widgetsManager.filters?.local.id || 0;

    if (localFilter) {
      data = data.filter((item) => item.id_local === localFilter);
    }

    this.data = data;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    return this.ordersService.getOrders();
  }

}
